import { useSession } from '@/features/auth/session-context';
import { DOCTOR_PROFILE_PERMISSIONS } from './types';

/** May this role open / edit doctors' public profiles (RL-905, RL-1175)? */
export function useDoctorProfileAccess() {
  const { hasPermission } = useSession();
  return {
    canRead: DOCTOR_PROFILE_PERMISSIONS.read.some((p) => hasPermission(p)),
    canEdit: DOCTOR_PROFILE_PERMISSIONS.manage.some((p) => hasPermission(p)),
  };
}
